import deparam from 'node-jquery-deparam';

export default class Browser {
  static getDocument() {
    return document;
  }

  static getWindow() {
    return window;
  }

  static getQueryParams() {
    const paramString = Browser.getWindow().location.search;

    return deparam(paramString.substring(1));
  }
}



// WEBPACK FOOTER //
// ./~/gwi-api/~/browser/src/browser.js